import { playlistDB } from './database';

export const loadPlaylistsForAccount = (accountID: string) => playlistDB.playlists.where({ accountID }).toArray();
